import React from "react";
import { ArrowRight, Activity, Droplets, Factory, Server } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectors = [{
  id: "saude",
  title: "Saúde e Hospitalar",
  description: "Climatização de precisão para ressonância magnética e centros cirúrgicos.",
  icon: <Activity className="w-8 h-8" />,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/hospital_mri_room.png",
  link: "/SolutionsPage"
}, {
  id: "salas-limpas",
  title: "Salas Limpas",
  description: "Controle rigoroso de partículas e umidade para a indústria farmacêutica.",
  icon: <Droplets className="w-8 h-8" />,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/clean_room_pharma.png",
  link: "/SolutionsPage"
}, {
  id: "industria",
  title: "Indústria e Processos",
  description: "Soluções térmicas robustas para linhas de produção e resfriamento industrial.",
  icon: <Factory className="w-8 h-8" />,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/industrial_processing_plant.png",
  link: "/SolutionsPage"
}, {
  id: "telecom",
  title: "Telecom e Datacenters",
  description: "Eficiência energética e redundância para infraestrutura de dados crítica.",
  icon: <Server className="w-8 h-8" />,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/datacenter_server_rows.png",
  link: "/SolutionsPage"
}];
export default function EspecialidadesPorSetor() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="especialidades-por-setor" ref={ref} className={`py-24 bg-background relative overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" aria-hidden="true">
        <svg className="w-full h-full" width="100%" height="100%">
          <defs>
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 40L40 0H20L0 20M40 40V20L20 40" stroke="currentColor" strokeWidth="1" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Soluções Especializadas por Setor
          </h2>
          <p className="text-lg text-muted-foreground">
            Engenharia térmica aplicada a ambientes críticos. Selecione seu setor para conhecer nossas tecnologias de controle e precisão.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {sectors.map((sector, index) => <Link key={sector.id} to={sector.link} className="block h-full" data-index={index}>
              <Card className="group relative h-[450px] w-full overflow-hidden border-0 rounded-xl bg-muted transition-all duration-500 hover:shadow-xl">
                {}
                <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 bg-[url(${sector.image})]`} />
                
                {}
                <div className="absolute inset-0 bg-slate-950/80 transition-colors duration-500 group-hover:bg-slate-950/60" />

                {}
                <CardContent className="relative h-full flex flex-col justify-end p-8 text-white z-20">
                  <div className="mb-auto transform translate-y-4 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                    <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/20 backdrop-blur-sm border border-primary/30 text-primary-foreground mb-4">
                      {sector.icon}
                    </div>
                  </div>

                  <div className="transform transition-transform duration-500 group-hover:-translate-y-2">
                    <h3 className="text-2xl font-bold mb-3 text-white group-hover:text-primary-foreground transition-colors">
                      {sector.title}
                    </h3>
                    <p className="text-slate-300 text-sm leading-relaxed mb-6 opacity-90 group-hover:opacity-100">
                      {sector.description}
                    </p>
                    
                    <Button variant="default" className="w-full bg-white/10 hover:bg-white/20 text-white border border-white/20 backdrop-blur-sm opacity-0 translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                      Explorar Solução
                      <ArrowRight className="ml-2 w-4 h-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}